import { render, staticRenderFns } from "./BackofficeGerarCobrancaInformarPagamento.vue?vue&type=template&id=54939c13&scoped=true"
import script from "./BackofficeGerarCobrancaInformarPagamento.vue?vue&type=script&lang=ts"
export * from "./BackofficeGerarCobrancaInformarPagamento.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeGerarCobrancaInformarPagamento.vue?vue&type=style&index=0&id=54939c13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54939c13",
  null
  
)

export default component.exports